export default __webpack_public_path__ + "media/images/features/local_delivery/episode3/LP_05-f1f3365930976ac8ec851e492260e61a.jpg";